module.exports = __webpack_public_path__ + "static/LogoBlueEN-fc109d001d6a61d45b9e335a19524db3.svg";